/**
 * Shopify Dawn Theme - Custom D2C BYOB (Build Your Own Bundle) Controller
 * Torris Blends Luxury Aesthetic: Step 1 (Size Cards), Step 2 (Offer Cards),
 * 5-Column Product Grid, Sticky "Your Bundle" Sidebar, GoKwik Checkout Integration
 */

(function() {
  'use strict';

  // 1. CLIENT-APPROVED TIER PRICING CONFIGURATION
  const DEFAULT_CONFIG = {
    '15ml': {
      name: '15 ML Pocket Perfumes',
      unitLabel: '15 ML',
      minQty: 10,
      tiers: [
        { qty: 10, price: 2999, label: '10 Pieces' },
        { qty: 15, price: 4299, label: '15 Pieces' }
      ]
    },
    '50ml': {
      name: '50 ML Luxury Sprays',
      unitLabel: '50 ML',
      minQty: 5,
      tiers: [
        { qty: 5, price: 2999, label: '5 Pieces' },
        { qty: 8, price: 4699, label: '8 Pieces' },
        { qty: 10, price: 5599, label: '10 Pieces' },
        { qty: 12, price: 6499, label: '12 Pieces' }
      ]
    },
    '100ml': {
      name: '100 ML Signature Bottles',
      unitLabel: '100 ML',
      minQty: 4,
      tiers: [
        { qty: 4, price: 4499, label: '4 Pieces' },
        { qty: 5, price: 5299, label: '5 Pieces' },
        { qty: 6, price: 5799, label: '6 Pieces' },
        { qty: 7, price: 6799, label: '7 Pieces' },
        { qty: 8, price: 7999, label: '8 Pieces' }
      ]
    }
  };

  const CONFIG = window.BYOB_CUSTOM_CONFIG || DEFAULT_CONFIG;

  // 2. STATE MANAGEMENT
  let activeSize = '50ml'; // Default active tab
  const targetTiers = {
    '15ml': 10,
    '50ml': 5,
    '100ml': 4
  };
  const selections = {
    '15ml': {},
    '50ml': (typeof window !== 'undefined' && window.BYOB_DEMO_INITIAL_ITEMS) ? {
      'v-50-1': { id: 'v-50-1', title: 'Rose Bloom', image: 'https://images.unsplash.com/photo-1588405748880-12d1d2a59f75?auto=format&fit=crop&w=400&q=80', mrp: 1499, qty: 1 },
      'v-50-2': { id: 'v-50-2', title: 'Oud Prestige', image: 'https://images.unsplash.com/photo-1523293182086-7651a899d37f?auto=format&fit=crop&w=400&q=80', mrp: 1499, qty: 1 },
      'v-50-7': { id: 'v-50-7', title: 'Lavender Bliss', image: 'https://images.unsplash.com/photo-1541643600914-78b084683601?auto=format&fit=crop&w=400&q=80', mrp: 1499, qty: 1 },
      'v-50-9': { id: 'v-50-9', title: 'Jasmine Touch', image: 'https://images.unsplash.com/photo-1615397349754-cfa2066a298e?auto=format&fit=crop&w=400&q=80', mrp: 1499, qty: 1 },
      'v-50-3': { id: 'v-50-3', title: 'Citrus Fresh', image: 'https://images.unsplash.com/photo-1547887537-6158d64c35b3?auto=format&fit=crop&w=400&q=80', mrp: 1499, qty: 1 }
    } : {},
    '100ml': {}
  };

  // Helper: Format Indian Rupee Currency
  function formatMoney(amount) {
    const num = Math.round(amount);
    return '₹' + num.toLocaleString('en-IN');
  }

  function formatDecimal(amount) {
    return '₹' + (Number(amount).toFixed(2));
  }

  function selectTargetTier(qty) {
    const conf = CONFIG[activeSize];
    const match = conf.tiers.find(t => t.qty === qty);
    if (!match) return;

    targetTiers[activeSize] = qty;
    updateBYOBInterface();
  }
  window.selectTargetTier = selectTargetTier;

  // 3. DYNAMIC PRICING ENGINE (CLEAN UPGRADE & INSTANT DOWNGRADE)
  function calculateBundlePricing(sizeKey, totalQty) {
    const conf = CONFIG[sizeKey];
    if (!conf) return { bundlePrice: 0, effectivePrice: 0, targetQty: 0, isQualified: false, promptText: '' };

    const tiers = conf.tiers;
    const minQty = conf.minQty;
    const maxTier = tiers[tiers.length - 1];

    let currentTargetTier = tiers[0];

    if (totalQty < minQty) {
      currentTargetTier = tiers[0];
      targetTiers[sizeKey] = currentTargetTier.qty;
    } else {
      // Check for exact tier match first (e.g. 4 pcs in 100ml -> 4 pcs tier @ ₹4,499)
      const exactMatch = tiers.find(t => t.qty === totalQty);
      if (exactMatch) {
        currentTargetTier = exactMatch;
        targetTiers[sizeKey] = exactMatch.qty;
      } else {
        // If between tiers (e.g. 6 pcs in 50ml where tiers are 5 and 8):
        // Pick the next higher tier to complete
        const nextHigher = tiers.find(t => t.qty > totalQty);
        currentTargetTier = nextHigher || maxTier;
        targetTiers[sizeKey] = currentTargetTier.qty;
      }
    }

    const isQualified = totalQty >= currentTargetTier.qty;
    const bundlePrice = currentTargetTier.price;
    const effectivePrice = bundlePrice / currentTargetTier.qty;
    const needed = Math.max(0, currentTargetTier.qty - totalQty);

    let promptText = '';
    if (totalQty < currentTargetTier.qty) {
      promptText = `Add ${needed} more to complete ${currentTargetTier.label} for ${formatMoney(bundlePrice)}`;
    } else {
      const nextTier = tiers.find(t => t.qty > currentTargetTier.qty);
      if (nextTier) {
        promptText = `Add ${nextTier.qty - totalQty} more to unlock ${nextTier.label} for ${formatMoney(nextTier.price)}`;
      } else {
        promptText = 'Maximum Bundle Value Unlocked!';
      }
    }

    return {
      bundlePrice,
      effectivePrice,
      currentTargetTier,
      targetQty: currentTargetTier.qty,
      isQualified,
      needed,
      promptText
    };
  }

  // 4. GET TOTALS FOR ACTIVE TAB
  function getActiveSelectionsCount() {
    const activeObj = selections[activeSize];
    return Object.values(activeObj).reduce((sum, item) => sum + item.qty, 0);
  }

  function getActiveTotalMrp() {
    const activeObj = selections[activeSize];
    return Object.values(activeObj).reduce((sum, item) => sum + (item.mrp * item.qty), 0);
  }

  // Pure Vanilla Confetti Engine for BYOB Completion Celebration
  let _byobConfettiParticles = [];
  let _byobConfettiAnimId = null;

  function fireByobConfetti() {
    const canvas = document.getElementById('ByobConfettiCanvas');
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    const colors = ['#fe3d00', '#ff8533', '#FFD700', '#FFFFFF', '#111111', '#FF3366', '#00E5FF'];
    const centerX = canvas.width / 2;
    const centerY = canvas.height * 0.35;

    for (let i = 0; i < 95; i++) {
      _byobConfettiParticles.push({
        x: centerX,
        y: centerY,
        size: Math.random() * 8 + 4,
        speedX: (Math.random() - 0.5) * 14,
        speedY: (Math.random() - 1.2) * 16,
        gravity: 0.45,
        rotation: Math.random() * 360,
        rotationSpeed: (Math.random() - 0.5) * 12,
        color: colors[Math.floor(Math.random() * colors.length)],
        alpha: 1,
        decay: Math.random() * 0.015 + 0.01
      });
    }

    if (!_byobConfettiAnimId) {
      function renderConfetti() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        _byobConfettiParticles.forEach((p, idx) => {
          p.x += p.speedX;
          p.y += p.speedY;
          p.speedY += p.gravity;
          p.rotation += p.rotationSpeed;
          p.alpha -= p.decay;

          ctx.save();
          ctx.translate(p.x, p.y);
          ctx.rotate((p.rotation * Math.PI) / 180);
          ctx.globalAlpha = Math.max(0, p.alpha);
          ctx.fillStyle = p.color;
          ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size * 0.6);
          ctx.restore();

          if (p.alpha <= 0 || p.y > canvas.height) {
            _byobConfettiParticles.splice(idx, 1);
          }
        });

        if (_byobConfettiParticles.length > 0) {
          _byobConfettiAnimId = requestAnimationFrame(renderConfetti);
        } else {
          cancelAnimationFrame(_byobConfettiAnimId);
          _byobConfettiAnimId = null;
          ctx.clearRect(0, 0, canvas.width, canvas.height);
        }
      }
      renderConfetti();
    }
  }

  // 5. UPDATE ALL UI ELEMENTS IN REAL-TIME
  function updateBYOBInterface() {
    const totalQty = getActiveSelectionsCount();
    const conf = CONFIG[activeSize];
    const pricing = calculateBundlePricing(activeSize, totalQty);
    const totalMrp = getActiveTotalMrp();
    const maxTierQty = conf.tiers[conf.tiers.length - 1].qty;
    const currentEffective = pricing.effectivePrice > 0 ? pricing.effectivePrice : (conf.tiers[0].price / conf.minQty);

    // 1. Update Step 2: Bundle Offers Cards Active Highlight
    const offerCards = document.querySelectorAll('.byob-offer-card');
    offerCards.forEach(card => {
      const tierQty = parseInt(card.getAttribute('data-tier-qty') || '0', 10);
      if (tierQty === pricing.targetQty) {
        card.classList.add('active');
      } else {
        card.classList.remove('active');
      }
    });

    // 2. Update Product Cards in Grid
    document.querySelectorAll('.byob-product-card').forEach(card => {
      const variantId = card.getAttribute('data-variant-id');
      const itemInCart = selections[activeSize][variantId];
      const cardQty = itemInCart ? itemInCart.qty : 0;

      // Update Effective Price
      const effEl = card.querySelector('.byob-eff-price');
      if (effEl) {
        effEl.textContent = formatDecimal(currentEffective);
      }

      // Border highlight
      if (cardQty > 0) {
        card.classList.add('selected-active');
      } else {
        card.classList.remove('selected-active');
      }

      // Action button vs Stepper
      const actionsWrap = card.querySelector('.byob-card-actions');
      if (actionsWrap) {
        if (cardQty > 0) {
          actionsWrap.innerHTML = `
            <div class="byob-qty-stepper">
              <button type="button" class="byob-qty-btn minus" onclick="window.byobChangeQty('${variantId}', -1)" aria-label="Decrease">&minus;</button>
              <span class="byob-qty-val">${cardQty}</span>
              <button type="button" class="byob-qty-btn plus" onclick="window.byobChangeQty('${variantId}', 1)" aria-label="Increase">&plus;</button>
            </div>
          `;
        } else {
          actionsWrap.innerHTML = `
            <button type="button" class="byob-add-btn" onclick="window.byobAddProduct('${variantId}')">
              <span>Add</span>
              <span>&plus;</span>
            </button>
          `;
        }
      }
    });

    // 3. Update Sticky "Your Bundle" Sidebar
    // Count Label
    const countLabelEl = document.getElementById('ByobSidebarCount');
    if (countLabelEl) {
      countLabelEl.textContent = `Selected Products (${totalQty}/${pricing.targetQty})`;
    }

    // Mini Progress Bar
    const progressFillEl = document.getElementById('ByobSidebarProgressFill');
    if (progressFillEl) {
      const pct = Math.min(100, (totalQty / pricing.targetQty) * 100);
      progressFillEl.style.width = pct + '%';
    }

    // Selected Items List (Desktop Sidebar - Thumbnail Only, Title Removed)
    const listEl = document.getElementById('ByobSidebarList');
    if (listEl) {
      const activeItems = Object.values(selections[activeSize]);
      if (activeItems.length === 0) {
        listEl.innerHTML = `<div class="byob-empty-notice">No fragrances added yet.<br>Click "Add +" on the left to build your box.</div>`;
      } else {
        let listHtml = '';
        activeItems.forEach(item => {
          listHtml += `
            <div class="byob-sheet-thumb-card byob-desktop-thumb-card">
              <img src="${item.image || ''}" alt="Fragrance Bottle" class="byob-sheet-thumb-img" loading="lazy">
              <button type="button" class="byob-sheet-thumb-del" onclick="window.byobRemoveItem('${item.id}')" title="Remove fragrance" aria-label="Remove">&times;</button>
              ${item.qty > 1 ? `
                <div class="byob-sheet-thumb-stepper">
                  <button type="button" class="byob-sheet-stepper-btn" onclick="window.byobChangeQty('${item.id}', -1)" aria-label="Decrease">&minus;</button>
                  <span class="byob-sheet-stepper-val">${item.qty}</span>
                  <button type="button" class="byob-sheet-stepper-btn" onclick="window.byobChangeQty('${item.id}', 1)" aria-label="Increase">&plus;</button>
                </div>
              ` : ''}
            </div>
          `;
        });
        listEl.innerHTML = `<div class="byob-sheet-thumbs-grid byob-desktop-thumbs-grid">${listHtml}</div>`;
      }
    }

    // Price Breakdown
    const bundlePriceLabelEl = document.getElementById('ByobBundlePriceLabel');
    if (bundlePriceLabelEl) {
      bundlePriceLabelEl.textContent = `Bundle Price (${pricing.targetQty} Pieces)`;
    }

    const bundlePriceValEl = document.getElementById('ByobBundlePriceVal');
    if (bundlePriceValEl) {
      bundlePriceValEl.textContent = formatMoney(pricing.bundlePrice);
    }

    const effPriceValEl = document.getElementById('ByobSidebarEffPrice');
    if (effPriceValEl) {
      effPriceValEl.textContent = `${formatDecimal(currentEffective)}`;
    }

    // DYNAMIC BUNDLE COMPLETION CELEBRATION (Desktop + Mobile)
    const desktopBanner = document.getElementById('ByobCelebrationBanner');
    const mobileBanner = document.getElementById('ByobMobileCelebrationBanner');
    const ctaBtn = document.getElementById('ByobCheckoutBtn');
    const mobileBtn = document.getElementById('ByobMobileStickyBtn');
    const sheetBtn = document.getElementById('ByobSheetCheckoutBtn');

    if (pricing.isQualified) {
      if (!window._byobCelebrated) {
        window._byobCelebrated = true;
        fireByobConfetti();
      }

      const celebrationSubText = `${pricing.targetQty} Pcs Box Complete! Flat ${formatMoney(pricing.bundlePrice)}`;
      if (desktopBanner) {
        desktopBanner.style.display = 'block';
        const sub = document.getElementById('ByobCelebrationSub');
        if (sub) sub.textContent = celebrationSubText;
      }
      if (mobileBanner) {
        mobileBanner.style.display = 'block';
        const sub = document.getElementById('ByobMobileCelebrationSub');
        if (sub) sub.textContent = celebrationSubText;
      }

      if (ctaBtn) {
        ctaBtn.disabled = false;
        ctaBtn.classList.add('pulse-glow-btn');
        ctaBtn.innerHTML = `<span>🎉 ADD TO CART &bull; ${formatMoney(pricing.bundlePrice)}</span>`;
      }
      if (mobileBtn) {
        mobileBtn.disabled = false;
        mobileBtn.classList.add('pulse-glow-btn');
        mobileBtn.innerHTML = `<span>🎉 ADD TO CART &bull; ${formatMoney(pricing.bundlePrice)}</span>`;
      }
      if (sheetBtn) {
        sheetBtn.disabled = false;
        sheetBtn.classList.add('pulse-glow-btn');
        sheetBtn.innerHTML = `<span>🎉 ADD TO CART &bull; ${formatMoney(pricing.bundlePrice)}</span>`;
      }
    } else {
      window._byobCelebrated = false;
      if (desktopBanner) desktopBanner.style.display = 'none';
      if (mobileBanner) mobileBanner.style.display = 'none';

      if (ctaBtn) {
        ctaBtn.disabled = true;
        ctaBtn.classList.remove('pulse-glow-btn');
        ctaBtn.innerHTML = `<span>ADD ${pricing.needed} MORE TO UNLOCK</span>`;
      }
      if (mobileBtn) {
        mobileBtn.disabled = true;
        mobileBtn.classList.remove('pulse-glow-btn');
        mobileBtn.innerHTML = `<span>ADD ${pricing.needed} MORE</span>`;
      }
      if (sheetBtn) {
        sheetBtn.disabled = true;
        sheetBtn.classList.remove('pulse-glow-btn');
        sheetBtn.innerHTML = `<span>ADD ${pricing.needed} MORE TO UNLOCK</span>`;
      }
    }

    // EMI Available Note (Desktop + Mobile Sticky Bar + Mobile Slide-Up Sheet)
    const emiHtml = pricing.bundlePrice > 0 
      ? `EMI available from  on All Bundle at Checkout`
      : `EMI available on credit/debit cards & UPI`;

    const emiTextEl = document.getElementById('ByobEmiText');
    if (emiTextEl) emiTextEl.innerHTML = emiHtml;

    const mobileStickyEmiTextEl = document.getElementById('ByobMobileStickyEmiText');
    if (mobileStickyEmiTextEl) mobileStickyEmiTextEl.innerHTML = emiHtml;

    const mobileSheetEmiTextEl = document.getElementById('ByobMobileSheetEmiText');
    if (mobileSheetEmiTextEl) mobileSheetEmiTextEl.innerHTML = emiHtml;

    // Sync Mobile Bottom Sticky Bar
    const mobileCountEl = document.getElementById('ByobMobileStickyCount');
    if (mobileCountEl) {
      mobileCountEl.textContent = `${totalQty}/${pricing.targetQty} Selected`;
    }

    const mobilePriceEl = document.getElementById('ByobMobileStickyPrice');
    if (mobilePriceEl) {
      mobilePriceEl.textContent = formatMoney(pricing.bundlePrice);
    }

    // Render Mini Fragrance Thumbnails directly on Sticky Bar
    const stickyThumbsEl = document.getElementById('ByobMobileStickyThumbs');
    if (stickyThumbsEl) {
      const activeItems = Object.values(selections[activeSize]);
      if (activeItems.length === 0) {
        stickyThumbsEl.innerHTML = '';
        stickyThumbsEl.style.display = 'none';
      } else {
        stickyThumbsEl.style.display = 'flex';
        let thumbsHtml = '';
        activeItems.slice(0, 4).forEach(item => {
          thumbsHtml += `
            <div class="byob-sticky-mini-thumb-wrap">
              <img src="${item.image || ''}" alt="Fragrance Bottle" class="byob-sticky-mini-thumb" loading="lazy">
              ${item.qty > 1 ? `<span class="byob-sticky-mini-qty">${item.qty}</span>` : ''}
            </div>
          `;
        });
        if (activeItems.length > 4) {
          thumbsHtml += `<span class="byob-sticky-more-count">+${activeItems.length - 4}</span>`;
        }
        stickyThumbsEl.innerHTML = thumbsHtml;
      }
    }

    // Sync Option 1: Mobile Slide-Up Sheet (Thumbnail ONLY - Title Removed)
    const sheetBadgeEl = document.getElementById('ByobSheetBadge');
    if (sheetBadgeEl) {
      sheetBadgeEl.textContent = `${totalQty}/${pricing.targetQty} Selected`;
    }

    const sheetTotalValEl = document.getElementById('ByobSheetTotalVal');
    if (sheetTotalValEl) {
      sheetTotalValEl.textContent = formatMoney(pricing.bundlePrice);
    }

    const sheetListEl = document.getElementById('ByobSheetList');
    if (sheetListEl) {
      const activeItems = Object.values(selections[activeSize]);
      if (activeItems.length === 0) {
        sheetListEl.innerHTML = `<div class="byob-sheet-empty">No perfumes added yet.<br>Tap <strong>+ Add</strong> on perfumes above to fill your box!</div>`;
      } else {
        let sheetHtml = '';
        activeItems.forEach(item => {
          sheetHtml += `
            <div class="byob-sheet-thumb-card">
              <img src="${item.image || ''}" alt="Fragrance Bottle" class="byob-sheet-thumb-img" loading="lazy">
              <button type="button" class="byob-sheet-thumb-del" onclick="window.byobRemoveItem('${item.id}')" title="Remove fragrance" aria-label="Remove">&times;</button>
              ${item.qty > 1 ? `
                <div class="byob-sheet-thumb-stepper">
                  <button type="button" class="byob-sheet-stepper-btn" onclick="window.byobChangeQty('${item.id}', -1)" aria-label="Decrease">&minus;</button>
                  <span class="byob-sheet-stepper-val">${item.qty}</span>
                  <button type="button" class="byob-sheet-stepper-btn" onclick="window.byobChangeQty('${item.id}', 1)" aria-label="Increase">&plus;</button>
                </div>
              ` : ''}
            </div>
          `;
        });
        sheetListEl.innerHTML = `<div class="byob-sheet-thumbs-grid">${sheetHtml}</div>`;
      }
    }
  }

  // Mobile Slide-Up Sheet Toggle (Option 1)
  function toggleByobMobileSheet(forceState) {
    const sheet = document.getElementById('ByobMobileSheet');
    const overlay = document.getElementById('ByobMobileSheetOverlay');
    const trigger = document.getElementById('ByobMobileViewTrigger');
    if (!sheet || !overlay) return;

    const isOpen = (typeof forceState === 'boolean') ? forceState : !sheet.classList.contains('active');
    if (isOpen) {
      sheet.classList.add('active');
      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
      if (trigger) trigger.innerHTML = 'Hide Items &#9660;';
    } else {
      sheet.classList.remove('active');
      overlay.classList.remove('active');
      document.body.style.overflow = '';
      if (trigger) trigger.innerHTML = 'View Items &#9650;';
    }
  }
  window.toggleByobMobileSheet = toggleByobMobileSheet;

  // 6. ACTIONS: ADD / CHANGE / REMOVE / CLEAR
  function byobAddProduct(variantId) {
    const totalQty = getActiveSelectionsCount();
    const conf = CONFIG[activeSize];
    const maxQty = conf.tiers[conf.tiers.length - 1].qty;
    if (totalQty >= maxQty) {
      alert(`You have reached the maximum quantity of ${maxQty} bottles for this ${conf.unitLabel} bundle box.`);
      return;
    }

    const card = document.querySelector(`.byob-product-card[data-variant-id="${variantId}"]`);
    if (!card) return;

    const title = card.getAttribute('data-product-title') || 'Perfume';
    const image = card.getAttribute('data-product-image') || '';
    const mrp = parseFloat(card.getAttribute('data-product-mrp') || '799');

    if (!selections[activeSize][variantId]) {
      selections[activeSize][variantId] = {
        id: variantId,
        title,
        image,
        mrp,
        qty: 0
      };
    }

    selections[activeSize][variantId].qty += 1;
    updateBYOBInterface();
  }
  window.byobAddProduct = byobAddProduct;

  function byobChangeQty(variantId, delta) {
    if (!selections[activeSize][variantId]) return;

    if (delta > 0) {
      const totalQty = getActiveSelectionsCount();
      const conf = CONFIG[activeSize];
      const maxQty = conf.tiers[conf.tiers.length - 1].qty;
      if (totalQty >= maxQty) {
        alert(`You have reached the maximum quantity of ${maxQty} bottles for this ${conf.unitLabel} bundle box.`);
        return;
      }
    }

    selections[activeSize][variantId].qty += delta;
    if (selections[activeSize][variantId].qty <= 0) {
      delete selections[activeSize][variantId];
    }
    updateBYOBInterface();
  }
  window.byobChangeQty = byobChangeQty;

  function byobRemoveItem(variantId) {
    if (selections[activeSize][variantId]) {
      delete selections[activeSize][variantId];
      updateBYOBInterface();
    }
  }
  window.byobRemoveItem = byobRemoveItem;

  function byobClearAll() {
    selections[activeSize] = {};
    updateBYOBInterface();
  }
  window.byobClearAll = byobClearAll;

  // 7. BOTTLE SIZE SWITCHER (15ML / 50ML / 100ML)
  function switchBottleSize(sizeKey) {
    if (!CONFIG[sizeKey]) return;
    activeSize = sizeKey;

    // Update Step 1 Size Cards active state
    document.querySelectorAll('.byob-size-card').forEach(card => {
      if (card.getAttribute('data-size') === sizeKey) {
        card.classList.add('active');
      } else {
        card.classList.remove('active');
      }
    });

    // Re-render Step 2 Offer Cards for this size
    const conf = CONFIG[sizeKey];
    const offersContainer = document.getElementById('ByobOffersCards');
    if (offersContainer) {
      let offersHtml = '';
      conf.tiers.forEach(tier => {
        const isTarget = tier.qty === (targetTiers[sizeKey] || conf.minQty);
        offersHtml += `
          <div class="byob-offer-card ${isTarget ? 'active' : ''}" data-tier-qty="${tier.qty}" onclick="window.selectTargetTier(${tier.qty})">
            <span class="byob-offer-check">&check;</span>
            <div class="byob-offer-qty">${tier.label}</div>
            <div class="byob-offer-price">${formatMoney(tier.price)}</div>
          </div>
        `;
      });
      offersContainer.innerHTML = offersHtml;
    }

    // Filter Products Grid for this size
    const searchInput = document.getElementById('ByobSearchInput');
    const query = searchInput ? searchInput.value.toLowerCase().trim() : '';

    document.querySelectorAll('.byob-product-card').forEach(card => {
      const cardSize = card.getAttribute('data-bottle-size');
      const sizeMatches = (!cardSize || cardSize === sizeKey || cardSize === 'all');
      const title = (card.getAttribute('data-product-title') || '').toLowerCase();

      if (sizeMatches && (query === '' || title.includes(query))) {
        card.style.display = 'flex';
      } else {
        card.style.display = 'none';
      }
    });

    updateBYOBInterface();
  }
  window.switchBottleSize = switchBottleSize;

  // 8. ADD BUNDLE TO CART WITH GOKWIK CHECKOUT PROPERTIES
  async function submitByobBundleToCart() {
    const totalQty = getActiveSelectionsCount();
    const conf = CONFIG[activeSize];
    const pricing = calculateBundlePricing(activeSize, totalQty);

    if (!pricing.isQualified) {
      alert(`Please select at least ${pricing.needed} more bottle(s) to complete your ${pricing.targetQty} Pieces bundle.`);
      return;
    }

    const ctaBtn = document.getElementById('ByobCheckoutBtn');
    const mobileBtn = document.getElementById('ByobMobileStickyBtn');
    const sheetBtn = document.getElementById('ByobSheetCheckoutBtn');
    if (ctaBtn) {
      ctaBtn.disabled = true;
      ctaBtn.innerHTML = `<span>Adding Bundle to Cart...</span>`;
    }
    if (mobileBtn) {
      mobileBtn.disabled = true;
      mobileBtn.innerHTML = `<span>Adding...</span>`;
    }
    if (sheetBtn) {
      sheetBtn.disabled = true;
      sheetBtn.innerHTML = `<span>Adding...</span>`;
    }

    const bundleId = 'BYOB-' + activeSize.toUpperCase() + '-' + Date.now();
    const bundleTitle = `${conf.unitLabel} Custom Box (${totalQty} Bottles)`;

    const itemsToAdd = [];
    const activeItems = Object.values(selections[activeSize]);

    // Check if merchant configured a Bundle Box Product in Shopify
    if (conf.bundleProduct && conf.bundleProduct.variants && conf.bundleProduct.variants.length > 0) {
      let targetVariant = null;

      // 1. Try matching by quantity in variant title (e.g. "8 Pieces", "8 Pcs", "8 Bottles")
      const qtyStr = String(pricing.targetQty);
      targetVariant = conf.bundleProduct.variants.find(v => {
        const t = (v.title || '').toLowerCase();
        return t.includes(`${qtyStr} piece`) || t.includes(`${qtyStr} pc`) || t.includes(`${qtyStr} bottle`) || t.includes(`${qtyStr}pk`) || t.trim() === qtyStr;
      });

      // 2. If not matched, try matching by tier index in config
      if (!targetVariant) {
        const tierIdx = conf.tiers.findIndex(t => t.qty === pricing.targetQty);
        if (tierIdx !== -1 && conf.bundleProduct.variants[tierIdx]) {
          targetVariant = conf.bundleProduct.variants[tierIdx];
        }
      }

      // 3. If not matched, try matching by price
      if (!targetVariant) {
        targetVariant = conf.bundleProduct.variants.find(v => v.price === pricing.bundlePrice);
      }

      // 4. Fallback to first variant if still not found
      if (!targetVariant) {
        targetVariant = conf.bundleProduct.variants[0];
      }

      const perfumesList = activeItems.map(it => `${it.qty}x ${it.title}`).join(', ');
      const properties = {
        '_bundle_id': bundleId,
        'Selected Fragrances': perfumesList,
        'Box Size': conf.unitLabel,
        'Pack Size': `${pricing.targetQty} Pieces`,
        'Total Bottles': totalQty,
        'Bundle Price': formatMoney(pricing.bundlePrice)
      };

      activeItems.forEach((it, idx) => {
        properties[`Bottle ${idx + 1}`] = `${it.title} (${it.qty}x)`;
      });

      itemsToAdd.push({
        id: targetVariant.id,
        quantity: 1,
        properties: properties
      });
    } else {
      activeItems.forEach(item => {
        itemsToAdd.push({
          id: item.id,
          quantity: item.qty,
          properties: {
            '_bundle_id': bundleId,
            '_bundle_size': activeSize.toUpperCase(),
            '_bundle_price': pricing.bundlePrice,
            '_bundle_effective_price': pricing.effectivePrice,
            'Bundle': bundleTitle
          }
        });
      });
    }

    try {
      // 1. Auto-cleanup: remove any existing bundle from cart so bundles never stack!
      try {
        const cartRes = await fetch('/cart.js');
        if (cartRes.ok) {
          const cartData = await cartRes.json();
          const updates = {};
          let needsCleanup = false;

          cartData.items.forEach(cartItem => {
            const itemTitleLower = (cartItem.title || cartItem.product_title || '').toLowerCase();
            const props = cartItem.properties || {};
            const isBundleBox = itemTitleLower.includes('bundle box') || itemTitleLower.includes('custom bundle') || itemTitleLower.includes('byob') || Boolean(props['_bundle_id']);
            const matchesSameSize = itemTitleLower.includes(conf.unitLabel.toLowerCase()) || props['Box Size'] === conf.unitLabel || (props['_bundle_id'] && props['_bundle_id'].includes(activeSize.toUpperCase()));

            // Replace only if it is the same bottle size (allows 50ML, 100ML, 15ML bundles to co-exist in cart)
            if (isBundleBox && matchesSameSize) {
              updates[cartItem.key] = 0;
              needsCleanup = true;
            }
          });

          if (needsCleanup) {
            await fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ updates })
            });
          }
        }
      } catch (cleanErr) {
        console.warn('Could not cleanup previous bundle in cart:', cleanErr);
      }

      // 2. Add the newly selected bundle to cart
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: itemsToAdd })
      });

      if (res.ok) {
        sessionStorage.setItem('just_added_bundle', 'true');
        toggleByobMobileSheet(false);
        if (typeof window.openCustomCartDrawer === 'function') {
          window.openCustomCartDrawer();
          if (typeof window.refreshDrawerFromServer === 'function') {
            await window.refreshDrawerFromServer();
          }
        } else {
          window.location.href = '/cart';
        }
      } else {
        const errorJson = await res.json();
        alert(errorJson.description || 'Could not add bundle to cart. Please try again.');
      }
    } catch (err) {
      console.error('Error adding BYOB bundle:', err);
      window.location.href = '/cart';
    } finally {
      updateBYOBInterface();
    }
  }
  window.submitByobBundleToCart = submitByobBundleToCart;

  // 9. SEARCH FILTER & INITIAL LOAD
  document.addEventListener('DOMContentLoaded', () => {
    // Initial Size Tab Load (Default: 50ml)
    switchBottleSize('50ml');

    // Search filter input listener
    const searchInput = document.getElementById('ByobSearchInput');
    if (searchInput) {
      searchInput.addEventListener('input', (e) => {
        const query = e.target.value.toLowerCase().trim();
        document.querySelectorAll('.byob-product-card').forEach(card => {
          const cardSize = card.getAttribute('data-bottle-size');
          const sizeMatches = (!cardSize || cardSize === activeSize || cardSize === 'all');
          const title = (card.getAttribute('data-product-title') || '').toLowerCase();

          if (sizeMatches && (query === '' || title.includes(query))) {
            card.style.display = 'flex';
          } else {
            card.style.display = 'none';
          }
        });
      });
    }
  });

})();
